import { createPath, createNavigationHook } from 'src/shared/navigation/RouteNavigationToolkit';

import type { QuestionnaireType } from '../pages/PathwayCreateQuestionnairePage';

const routes = {
    pathways: createPath('/pathways'),
    aboutPathways: createPath('/pathways/about'),
    pathway: createPath<{ uuid: string }>('/pathways/:uuid'),
    pathwayAssessment: createPath<{ uuid: string }>('/pathways/:uuid/assessment'),
    pathwayReview: createPath<{ uuid: string }>('/pathways/:uuid/review'),
    createPathway: createPath<{ uuid: string }>('/pathways/:uuid/create'),
    createPathwayQuestionnaire: createPath<{ uuid: string }>(
        '/pathways/:uuid/create/questionnaire',
    ),
    createPathwayQuestionnaireType: createPath<{
        uuid: string;
        questionnaireType: QuestionnaireType;
    }>('/pathways/:uuid/create/questionnaire/:questionnaireType'),
    createPathwaySummary: createPath<{ uuid: string }>('/pathways/:uuid/create/summary'),
};

export const usePathwaysNavigation = createNavigationHook(routes);
